import { render, staticRenderFns } from "./OneDimensionalScatterChartPlotly.vue?vue&type=template&id=2685ef03&scoped=true&"
import script from "./OneDimensionalScatterChartPlotly.vue?vue&type=script&lang=js&"
export * from "./OneDimensionalScatterChartPlotly.vue?vue&type=script&lang=js&"
import style0 from "./OneDimensionalScatterChartPlotly.vue?vue&type=style&index=0&id=2685ef03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2685ef03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2685ef03')) {
      api.createRecord('2685ef03', component.options)
    } else {
      api.reload('2685ef03', component.options)
    }
    module.hot.accept("./OneDimensionalScatterChartPlotly.vue?vue&type=template&id=2685ef03&scoped=true&", function () {
      api.rerender('2685ef03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/charts/OneDimensionalScatterChartPlotly.vue"
export default component.exports